import React from "react";

const StartNowBlocks1 = ({ className, ...props }) => {
  return (
    <svg
      width="290"
      height="190"
      viewBox="0 0 290 190"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g filter="url(#filter0_f_2918_7929)">
        <ellipse
          cx="145"
          cy="139.5"
          rx="105"
          ry="10.5"
          fill="url(#paint0_radial_2918_7929)"
        />
      </g>
      <path
        d="M143.659 58.5753L135.839 53.5286L111.325 66.2495L119.144 71.293L143.659 58.5753Z"
        fill="url(#paint1_linear_2918_7929)"
      />
      <path
        d="M119.144 71.2937L111.325 66.2502L119.803 90.9441L127.62 95.9922L119.144 71.2937Z"
        fill="url(#paint2_linear_2918_7929)"
      />
      <path
        d="M135.18 33.8786L127.365 28.8338L135.839 53.529L143.659 58.5758L135.18 33.8786Z"
        fill="url(#paint3_linear_2918_7929)"
      />
      <path
        d="M159.694 21.1613L151.875 16.1145L127.365 28.8341L135.18 33.8789L159.694 21.1613Z"
        fill="url(#paint4_linear_2918_7929)"
      />
      <path
        d="M176.648 70.5533L159.694 21.1608L135.18 33.8785L143.659 58.5757L119.144 71.2934L127.62 95.9919L176.648 70.5533Z"
        fill="url(#paint5_radial_2918_7929)"
      />
      <g filter="url(#filter1_d_2918_7929)">
        <path
          d="M172.111 71.1235L164.296 66.0786L136.81 80.3369L144.63 85.3837L172.111 71.1235Z"
          fill="url(#paint6_linear_2918_7929)"
        />
        <path
          d="M144.63 85.3833L136.81 80.3366L146.316 108.026L154.132 113.074L144.63 85.3833Z"
          fill="url(#paint7_linear_2918_7929)"
        />
        <path
          d="M162.608 43.4407L154.792 38.3926L164.296 66.0786L172.111 71.1234L162.608 43.4407Z"
          fill="url(#paint8_linear_2918_7929)"
        />
        <path
          d="M190.089 29.1801L182.273 24.132L154.792 38.3922L162.608 43.4403L190.089 29.1801Z"
          fill="url(#paint9_linear_2918_7929)"
        />
        <path
          d="M209.098 84.5523L190.089 29.1803L162.608 43.4405L172.111 71.1232L144.63 85.3835L154.132 113.074L209.098 84.5523Z"
          fill="url(#paint10_radial_2918_7929)"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_2918_7929"
          x="0"
          y="89"
          width="290"
          height="101"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="20"
            result="effect1_foregroundBlur_2918_7929"
          />
        </filter>
        <filter
          id="filter1_d_2918_7929"
          x="107.81"
          y="0.131836"
          width="112.287"
          height="128.942"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-9" dy="-4" />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2918_7929"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2918_7929"
            result="shape"
          />
        </filter>
        <radialGradient
          id="paint0_radial_2918_7929"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(145 139.5) rotate(90) scale(10.5 105)"
        >
          <stop />
          <stop offset="1" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_2918_7929"
          x1="131.136"
          y1="69.2095"
          x2="125.331"
          y2="58.4007"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset="1" stopColor="#003AEB" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2918_7929"
          x1="129.304"
          y1="105.336"
          x2="112.79"
          y2="64.6529"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset="1" stopColor="#003AEB" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2918_7929"
          x1="144.893"
          y1="37.1246"
          x2="129.724"
          y2="47.7296"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset="1" stopColor="#003AEB" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_2918_7929"
          x1="148.421"
          y1="32.5166"
          x2="140.94"
          y2="21.0537"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset="1" stopColor="#003AEB" />
        </linearGradient>
        <radialGradient
          id="paint5_radial_2918_7929"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(120.885 49.071) rotate(-22.4056) scale(76.2997 76.5812)"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="0.09" stopColor="#00E1FF" />
          <stop offset="0.25" stopColor="#00B0FF" />
          <stop offset="0.42" stopColor="#0087FF" />
          <stop offset="0.57" stopColor="#0068FF" />
          <stop offset="0.73" stopColor="#0051FF" />
          <stop offset="0.87" stopColor="#0044FF" />
          <stop offset="1" stopColor="#003FFF" />
        </radialGradient>
        <linearGradient
          id="paint6_linear_2918_7929"
          x1="159.347"
          y1="84.0638"
          x2="151.12"
          y2="70.0617"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00BEFF" />
          <stop offset="1" stopColor="#007BFF" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_2918_7929"
          x1="148.938"
          y1="107.268"
          x2="139.998"
          y2="79.9593"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00BEFF" />
          <stop offset="1" stopColor="#007BFF" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_2918_7929"
          x1="167.476"
          y1="52.7428"
          x2="158.743"
          y2="57.1151"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00BEFF" />
          <stop offset="1" stopColor="#007BFF" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_2918_7929"
          x1="177.624"
          y1="44.0265"
          x2="170.362"
          y2="29.6942"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00BEFF" />
          <stop offset="1" stopColor="#007BFF" />
        </linearGradient>
        <radialGradient
          id="paint10_radial_2918_7929"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(204.285 81.6079) rotate(-22.4056) scale(88.9791 89.3074)"
        >
          <stop stopColor="#00FFFF" />
          <stop offset="0.12" stopColor="#00FAFF" />
          <stop offset="0.27" stopColor="#00ECFF" />
          <stop offset="0.43" stopColor="#00D4FF" />
          <stop offset="0.59" stopColor="#00B3FF" />
          <stop offset="0.76" stopColor="#0089FF" />
          <stop offset="0.93" stopColor="#0055FF" />
          <stop offset="1" stopColor="#003FFF" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export default StartNowBlocks1;
